<template>
	<div>
		<el-row
			v-if="viewType == '1'"
			v-loading="isloading"
			class="reports-table-hide"
			style="margin-top: 14px; hidden"
		>
			<el-col :span="24">
				<el-table
					:show-header="true"
					style="text-transform: capitalize"
					:data="
						filteredreportsTable
							.filter(
								(el) =>
									!selected_Location.length ||
									selected_Location.includes(el.name)
							)
							.filter(
								(el) =>
									!search ||
									el.name.toLowerCase().includes(search.toLowerCase())
							)
							.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
					"
				>
					<el-table-column label="Location">
						<template slot="header" slot-scope="scope">
							{{
								selectedLocationType == "region"
									? regionType == 0
										? "Region"
										: regionType == 1
										? "Sub Region"
										: "Outlet"
									: "Location"
							}}
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Location"
									size="mini"
									:placeholder="`Search ${
										selectedLocationType == 'region'
											? regionType == 0
												? 'Region'
												: regionType == 1
												? 'Sub Region'
												: 'Outlet'
											: 'Location'
									}`"
								></el-input>
								<div
									style="max-height: 250px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Location">
										<el-checkbox
											v-for="(formItem, index) in uniqueLocationNames.filter(
												(el) =>
													!searched_Location ||
													el
														.toLowerCase()
														.includes(searched_Location.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Location = [...uniqueLocationNames]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Location = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Location.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="total" label="Total Projects">
						<template slot="header" slot-scope="scope">
							Total Projects
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_occurance_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = 'asc';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
								<i
									v-if="
										last_occurance_order == '' || last_occurance_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = 'desc';
										last_completed_order = '';
										last_total_points_order = '';
										last_completion_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="completed" label="Completed">
						<template slot="header" slot-scope="scope">
							Completed
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_completed_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = 'asc';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
								<i
									v-if="
										last_completed_order == '' || last_completed_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = 'desc';
										last_total_points_order = '';
										last_completion_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showCompletion"
						prop="completion_%"
						label="Completion %"
					>
						<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

						<template slot="header" slot-scope="scope">
							Completion %
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_completion_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = 'asc';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
								<i
									v-if="
										last_completion_order == '' ||
										last_completion_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = 'desc';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>

					<el-table-column
						v-if="showScore"
						prop="completed_total_score"
						label="Total Points"
					>
						<template slot="header" slot-scope="scope">
							Total Points
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_total_points_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = 'asc';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
								<i
									v-if="
										last_total_points_order == '' ||
										last_total_points_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = 'desc';
										last_points_achieved_oeder = '';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="completed_current_score"
						label="Points Achieved"
					>
						<template slot="header" slot-scope="scope">
							Points Achieved
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_points_achieved_oeder == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = 'asc';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
								<i
									v-if="
										last_points_achieved_oeder == '' ||
										last_points_achieved_oeder == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = 'desc';
										last_score_order = '';
										last_average_score_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="completed_score_%"
						label="Score %"
					>
						<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

						<template slot="header" slot-scope="scope">
							Score %
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_score_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_average_score_order = '';
										last_score_order = 'asc';
									"
								></i>
								<i
									v-if="last_score_order == '' || last_score_order == 'asc'"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									@click="
										last_occurance_order = '';
										last_completed_order = '';
										last_completion_order = '';
										last_total_points_order = '';
										last_points_achieved_oeder = '';
										last_average_score_order = '';
										last_score_order = 'desc';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<!-- <el-table-column
								prop="completed_score_%"
								label="Average Score %"
								v-if="showScore"
							>
								<template slot="header" slot-scope="scope">
									Average Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_average_score_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_average_score_order = 'asc';
												last_score_order = '';
											"
										></i>
										<i
											v-if="
												last_average_score_order == '' ||
												last_average_score_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = 'desc';
											"
										></i>
									</span>
								</template>
							</el-table-column> -->
				</el-table>
			</el-col>
		</el-row>
		<el-row
			v-loading="isloading"
			class="reports-table-hide"
			style="margin-top: 14px; hidden"
			v-if="viewType == '2'"
		>
			<el-col :span="24">
				<el-table
					:show-header="true"
					style="text-transform: capitalize"
					:data="
						filteredreportsTable
							.filter(
								(el) =>
									!selected_Location.length ||
									selected_Location.includes(el.name)
							)
							.filter(
								(el) =>
									!search ||
									el.name.toLowerCase().includes(search.toLowerCase())
							)
							.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
					"
				>
					<el-table-column label="Position"> </el-table-column>
					<el-table-column label="Location">
						<template slot="header" slot-scope="scope">
							{{ viewBy == "location" ? "Location" : "User" }}
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Location"
									size="mini"
									:placeholder="`Search ${
										viewBy == 'location' ? 'Location' : 'User'
									}`"
								></el-input>
								<div
									style="max-height: 250px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Location">
										<el-checkbox
											v-for="(formItem, index) in uniqueLocationNames.filter(
												(el) =>
													!searched_Location ||
													el
														.toLowerCase()
														.includes(searched_Location.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Location = [...uniqueLocationNames]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Location = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Location.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="total" label="Total Projects">
						<template slot="header" slot-scope="scope">
							Total Projects
						</template>
					</el-table-column>
					<el-table-column prop="completed" label="Completed">
						<template slot="header" slot-scope="scope"> Completed </template>
					</el-table-column>
					<el-table-column
						v-if="showCompletion"
						prop="completion_%"
						label="Completion %"
					>
						<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

						<template slot="header" slot-scope="scope"> Completion % </template>
					</el-table-column>

					<el-table-column
						v-if="showScore"
						prop="completed_total_score"
						label="Total Points"
					>
						<template slot="header" slot-scope="scope"> Total Points </template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="completed_current_score"
						label="Points Achieved"
					>
						<template slot="header" slot-scope="scope">
							Points Achieved
						</template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="completed_score_%"
						label="Score %"
					>
						<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

						<template slot="header" slot-scope="scope"> Score % </template>
					</el-table-column>
					<!-- <el-table-column
								prop="completed_score_%"
								label="Average Score %"
								v-if="showScore"
							>
								<template slot="header" slot-scope="scope">
									Average Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_average_score_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_average_score_order = 'asc';
												last_score_order = '';
											"
										></i>
										<i
											v-if="
												last_average_score_order == '' ||
												last_average_score_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = 'desc';
											"
										></i>
									</span>
								</template>
							</el-table-column> -->
				</el-table>
			</el-col>
		</el-row>
		<el-row
			v-loading="isloading"
			class="reports-table-hide"
			style="margin-top: 0px"
		>
			<el-col :span="24">
				<el-table
					:show-header="true"
					style="text-transform: capitalize"
					:data="SummaryreportsTable"
				>
					<el-table-column v-if="viewType == '2'" label=""> </el-table-column>
					<el-table-column>
						<template slot="header" slot-scope="scope">
							<div
								:style="
									selectedLocationType == 'region'
										? 'text-decoration: underline; cursor: pointer'
										: ''
								"
								@click="
									viewBy == 'location' && selectedLocationType == 'region'
										? open_report_dashboard(scope.row, scope.$index, 'TOTAL')
										: ''
								"
							>
								India
							</div>
						</template>
					</el-table-column>
					<el-table-column
						:label="get_reports_label('occurance')"
					></el-table-column>
					<el-table-column
						:label="get_reports_label('completed')"
					></el-table-column>
					<el-table-column
						v-if="showCompletion"
						:label="get_reports_label('completion')"
					></el-table-column>

					<el-table-column
						v-if="showScore"
						:label="get_reports_label('total')"
					></el-table-column>
					<el-table-column
						v-if="showScore"
						:label="get_reports_label('achieved')"
					></el-table-column>
					<el-table-column
						v-if="showScore"
						:label="get_reports_label('score')"
					></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row v-loading="isloading" class="reports-table-consolidated" style="">
			<el-col :span="24">
				<el-table
					:show-header="false"
					style="text-transform: capitalize"
					:data="
						reportsTable

							.filter(
								(el) =>
									!selected_Location.length ||
									selected_Location.includes(el.name)
							)
							.filter(
								(el) =>
									!search ||
									el.name.toLowerCase().includes(search.toLowerCase())
							)
							.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
					"
				>
					<el-table-column v-if="viewType == '2'" label="Position">
						<template slot-scope="scope">
							{{ scope.$index < 5 ? scope.$index + 1 : "" }}
						</template>
					</el-table-column>
					<el-table-column label="Location">
						<template slot-scope="scope">
							<div
								v-if="viewType == '1'"
								@click="
									viewBy == 'location'
										? open_report_dashboard(scope.row, scope.$index, 'ROW')
										: ''
								"
								:style="
									viewBy == 'location'
										? `text-transform: capitalize;
											margin-top: -5px;
											color: #d26300;
											cursor: pointer;
											word-break: break-word;`
										: `text-transform: capitalize;
											margin-top: -5px;
											word-break: break-word;`
								"
							>
								{{ scope.row.name }}
							</div>
							<div
								v-if="viewType == '2'"
								:style="
									viewBy == 'location'
										? `text-transform: capitalize;
											margin-top: -5px;
											
											word-break: break-word;`
										: `text-transform: capitalize;
											margin-top: -5px;
											word-break: break-word;`
								"
							>
								{{ scope.row.name }}
							</div>
						</template>
					</el-table-column>
					<el-table-column sortable prop="total" label="Occurence">
					</el-table-column>
					<el-table-column sortable prop="completed" label="Completed">
					</el-table-column>
					<el-table-column
						v-if="showCompletion"
						sortable
						prop="completion_%"
						label="Completion %"
					>
						<template slot-scope="scope">
							<div>{{ scope.row["completion_%"] }}%</div>
						</template>
					</el-table-column>

					<el-table-column
						v-if="showScore"
						sortable
						prop="completed_total_score"
						label="Total Points"
					>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						sortable
						prop="completed_current_score"
						label="Points Achieved"
					>
					</el-table-column>
					<el-table-column
						sortable
						prop="completed_score_%"
						label=""
						v-if="showScore"
					>
						<template slot-scope="scope">
							<div>{{ scope.row["completed_score_%"] }}%</div>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row :gutter="10" class="mt-3">
			<el-col :span="8" class="text-left">
				<div>
					<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
					{{ filteredreportsTable.length }} results
				</div>
			</el-col>
			<el-col :span="8" class="text-center">
				<el-select
					v-model="perPage"
					name="per_page"
					placeholder="select per page"
					style="width: 90px !important"
					size="mini"
				>
					<el-option v-if="viewType == '2'" label="5" :value="5"></el-option>
					<el-option label="10" :value="10"></el-option>
					<el-option label="25" :value="25"></el-option>
					<el-option label="50" :value="50"></el-option>
					<el-option label="100" :value="100"></el-option>
				</el-select>
				&nbsp;<b>per page</b>
			</el-col>
			<el-col :span="8" class="text-right">
				<el-pagination
					background
					layout="prev, pager, next"
					:total="filteredreportsTable.length"
					:page-size="perPage"
					:current-page.sync="currentPage"
				></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";

var moment = require("moment");
export default {
	props: {
		SummaryreportsTable: Array,
		reportsTable: Array,
		showScore: Boolean,
		showCompletion: Boolean,
		selectedLocationType: String,
		viewBy: String,
		search: String,
		viewType: String,
		dates: Array, 
		projectsTasks: String,
		projectsTasksItems: Array,
		category: String,
		forms: String,
		locations: null,
		is_outlet: Boolean,
		is_bt: Boolean,
		status: String,
		regionType: Number,
	},
	data: () => ({
		storeObj: {},
		moment: moment,
		searched_Location: "",
		last_occurance_order: "",
		last_completed_order: "",
		last_completion_order: "",
		last_points_achieved_oeder: "",
		last_average_score_order: "",
		last_total_points_order: "",
		last_score_order: "",
		selected_Location: [],
		currentPage: 1,
		perPage: 10,
		isloading: false,
	}),
	computed: {
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.reportsTable.length
			);
			return end;
		},
		uniqueLocationNames() {
			let arr = [...new Set([...this.reportsTable].map((el) => el.name))];
			return arr;
		},
		filteredreportsTable() {
			let array1 = this.reportsTable;
			if (this.last_occurance_order) {
				if (this.last_occurance_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a.total - b.total);
				}
				if (this.last_occurance_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b.total - a.total);
				}
			}
			if (this.last_completed_order) {
				if (this.last_completed_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a.completed - b.completed);
				}
				if (this.last_completed_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b.completed - a.completed);
				}
			}
			if (this.last_completion_order) {
				if (this.last_completion_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a["completion_%"] - b["completion_%"]);
				}
				if (this.last_completion_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b["completion_%"] - a["completion_%"]);
				}
			}
			if (this.last_score_order) {
				if (this.last_score_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_score_%"] - b["completed_score_%"]
					);
				}
				if (this.last_score_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
				}
			}
			if (this.last_total_points_order) {
				if (this.last_total_points_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_total_score"] - b["completed_total_score"]
					);
				}
				if (this.last_total_points_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_total_score"] - a["completed_total_score"]
					);
				}
			}
			if (this.last_points_achieved_oeder) {
				if (this.last_points_achieved_oeder.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) =>
							a["completed_current_score"] - b["completed_current_score"]
					);
				}
				if (
					this.last_points_achieved_oeder.toString().toLowerCase() == "desc"
				) {
					array1 = array1.sort(
						(a, b) =>
							b["completed_current_score"] - a["completed_current_score"]
					);
				}
			}
			if (this.last_average_score_order) {
				if (this.last_average_score_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_score_%"] - b["completed_score_%"]
					);
				}
				if (this.last_average_score_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
				}
			}
			this.$forceUpdate();
			return array1;
		},
	},
	watch: {
		viewType(val) {
			if (val == "2") this.perPage = 5;
			else this.perPage = 10;
		},
	},
	methods: {
		listusersData(item) {
			let from_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let to_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let params = {
				filters: {
					outlets: [item.basics],
					countries: [],
					regions: [],
					subregions: [],
				},
				start_date: from_date,
				end_date: to_date,
				project: this.projectsTasks,
				form_category: this.category !== "All" ? this.category : null,
				form: this.forms !== "All" ? this.forms : null,
				basics: "user",
				include_dates: true,
				get_country_avg: true,
				get_region_avg: true,
				status: this.status !== "All" ? this.status : null,
			};
			// if (this.is_bt) params.status = "completed";

			formBuilderServices.getDashboardData(params).then((res) => {
				this.storeObj.response2 = JSON.parse(res.data).data;
				// this.current_view = "Page_3";
				// this.$emit("hide_upper_tabs");
				// this.$forceUpdate();
				localStorage.setItem("storeObject", JSON.stringify(this.storeObj));

				this.$emit("showViewType4");
				this.$forceUpdate();
			});
		},
		open_report_dashboard(item, index, type) {
			this.storeObj = {};
			this.storeObj = item;
			if (!this.storeObj) {
				this.storeObj = {}; // Initialize as an empty object if it's undefined
			}
			this.storeObj.type = type;
			if (type == "TOTAL") {
				let from_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let to_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let params = {
					filters: {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					},
					start_date: from_date,
					end_date: to_date,
					project: this.projectsTasks,
					form_category: null,
					form: null,
					basics: "country",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};

				this.storeObj.params = params;
				formBuilderServices.getDashboardData(params).then((res) => {
					this.storeObj.response = JSON.parse(res.data);
					// this.current_view = "Page_3";
					// this.$emit("hide_upper_tabs");
					localStorage.setItem("storeObject", JSON.stringify(this.storeObj));
					this.$emit("showViewType4");
					this.$forceUpdate();
				});
			}
			if (type == "ROW") this.list_data_row_by_region(item);
		},
		list_data_row_by_region(item) {
			let lastElement = [];
			let lastIndex = 0;
			let from_date = moment(this.dates[0]).format("yyyy-MM-DD");
			let to_date = moment(this.dates[1]).format("yyyy-MM-DD");
			let params = {};
			if (this.selectedLocationType == "region") {
				for (let i = 0; i < this.locations.length; i++) {
					for (let j = 0; j < this.locations[i].length; j++) {
						lastIndex = j;
					}
				}
				for (let i = 0; i < this.locations.length; i++) {
					for (let j = 0; j < this.locations[i].length; j++) {
						lastElement.push(this.locations[i][lastIndex]);
					}
				}
				lastElement = [...new Set(lastElement)];
				params = {
					filters: {},
					start_date: from_date,
					end_date: to_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					basics:
						lastIndex == 3
							? "outlet"
							: lastIndex == 0
							? "region"
							: lastIndex == 1
							? "subregion"
							: lastIndex == 2
							? "outlet"
							: "",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};
				if (params.basics == "region") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [item.basics],
						subregions: [],
					};
				}
				if (params.basics == "subregion") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [item.basics],
					};
				}
				if (params.basics == "outlet") {
					params.filters = {
						outlets: [item.basics],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
			} else {
				params = {
					filters: {
						outlets: [item.basics],
						countries: [],
						regions: [],
						subregions: [],
					},
					start_date: from_date,
					end_date: to_date,
					project: this.projectsTasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					basics: "outlet",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};
			}
			this.storeObj.params = params;
			formBuilderServices.getDashboardData(params).then((res) => {
				this.storeObj.response = JSON.parse(res.data);

				if (this.is_outlet) {
					this.listusersData(item);
				} else {
					// this.current_view = "Page_3";
					// this.$emit("hide_upper_tabs");
					// this.$forceUpdate();
					localStorage.setItem("storeObject", JSON.stringify(this.storeObj));

					this.$emit("showViewType4");
					this.$forceUpdate();
				}
			});
		},
		get_reports_label(type) {
			if (this.SummaryreportsTable.length === 0) return "";
			switch (type) {
				case "label":
					return this.SummaryreportsTable[0].name
						? this.SummaryreportsTable[0].name.toString()
						: "";
				case "occurance":
					return this.SummaryreportsTable[0].total
						? this.SummaryreportsTable[0].total.toString()
						: "";
				case "completed":
					return this.SummaryreportsTable[0].completed
						? this.SummaryreportsTable[0].completed.toString()
						: "";
				case "completion":
					return this.SummaryreportsTable[0]["completion_%"]
						? this.SummaryreportsTable[0]["completion_%"] + "%"
						: "";
				case "total":
					return this.SummaryreportsTable[0].completed_total_score
						? this.SummaryreportsTable[0].completed_total_score.toString()
						: "";
				case "achieved":
					return this.SummaryreportsTable[0].completed_current_score
						? this.SummaryreportsTable[0].completed_current_score.toString()
						: "";
				case "score":
					return this.SummaryreportsTable[0]["completed_score_%"]
						? this.SummaryreportsTable[0]["completed_score_%"] + "%"
						: "";
				default:
					return "";
			}
		},
	},
};
</script>

<style></style>
